import { BigNumber } from "ethers";
import { prepareWriteContract, writeContract } from "wagmi/actions";
import { StakingAggregator__factory } from "staking-contract";

import { CURRENCY_SKEY } from "@src/constants/constants";
import { StakingData } from "@src/contexts/StakingsDataContext";

import { ConfirmTxModalProps } from "@src/components/modals/ConfirmTxModal/ConfirmTxModal";
import { SuccessTxModalProps } from "@src/components/modals/SuccessTxModal/SuccessTxModal";

import { config } from "../EthProvider";
import { TxHandler } from "./TxHandler";

export interface ClaimTxCommand {
  type: "claim";
  args: {
    data: StakingData;
  };
}

export class ClaimTxHandler extends TxHandler<ClaimTxCommand> {
  override createConfirmModalProps(): ConfirmTxModalProps {
    return {
      ...super.createConfirmModalProps(),
      title: this.ctx.t("txModalClaim.title"),
      continueText: this.ctx.t("txModalClaim.continue"),
      textRows: [
        {
          key: this.ctx.t("txModalClaim.rows.totalStaked"),
          value: `${this.formatSkey(this.ctx.stakedBalance)} ${CURRENCY_SKEY}`
        },
        {
          key: this.ctx.t("txModalClaim.rows.bonus"),
          value: this.cmd.args.data.data.earningPercent.percent
        },
        {
          key: this.ctx.t("txModalClaim.rows.duration"),
          value: `${this.cmd.args.data.months} ${this.ctx.commonT("months")}`
        },
        {
          key: this.ctx.t("txModalClaim.rows.after"),
          value: `${this.formatSkey(
            this.getBalanceAfter(this.cmd.args.data.data.earningPercent.bigNumber)
          )} ${CURRENCY_SKEY}`
        }
      ]
    };
  }

  override createSuccessModalProps(): SuccessTxModalProps {
    return {
      ...super.createSuccessModalProps(),
      info: {
        description: this.ctx.t("txModalSuccessClaim.info.description")
      }
    };
  }

  override async sendTx() {
    const tx = await prepareWriteContract({
      abi: StakingAggregator__factory.abi,
      address: config.aggregatorAddress,
      functionName: "claim",
      args: [BigNumber.from(0)]
    });

    await writeContract(tx).then((receipt) => receipt.wait());
  }
}
